import { ContextData } from 'src/app/data/context.data';

export class TemplateLayoutData {

  private _templateID:number;
  private _x:number;
  private _y:number;
  private _rotation:number;
  private _checkBoxX:number;
  private _checkBoxY:number;

  private _data:any;

  constructor(data:any = null) {
    if (data) {
      this.data = data;
    }
  }

  /**
	 * data
	 */
  public set data(value: any) {
    this._data = value;

    this._templateID = this._data.labelId;
    this._x = this._data.x;
    this._y = this._data.y;
    this._rotation = this._data.rotation;
    this._checkBoxX = this._data.checkBoxX;
    this._checkBoxY = this._data.checkBoxY;
  }

  public get templateID():number {
    return this._templateID;
  }

  public get x():number {
    return this._x;
  }
  public get pixelsX():number {
    return this.x * ContextData.MM_TO_PIXELS;
  }

  public get y():number {
    return this._y;
  }
  public get pixelsY():number {
    return this.y * ContextData.MM_TO_PIXELS;
  }

  public get rotation():number {
    return this._rotation;
  }

  public get checkBoxX():number {
    return this._checkBoxX * ContextData.MM_TO_PIXELS;
  }

  public get checkBoxY():number {
    return this._checkBoxY * ContextData.MM_TO_PIXELS;
  }

  public toString():string {
    return "TemplateLayoutData{_templateID:\"" + this._templateID + "\", _x:" +this. _x + ", _y:" + this._y + ", _rotation:" + this._rotation + "}";
  }

}
